import Card from "./Card";
import ProgressBar from "Components/Common/ProgressBar/ProgressBar";

interface BudgetRow {
  label: string;
  value: string;
  isTotal?: boolean;
  variant?: string;
  size?: string;
}

interface BudgetProgress {
  timeClass: string;
  timeValue: string;
  workClass: string;
  workValue: string;
}

interface BudgetSummaryProps {
  title: string;
  rows: BudgetRow[];
  note?: string;
  noteClass?: string;
  progress?: BudgetProgress;
}

const BudgetSummary = ({ title, rows, note, noteClass, progress }: BudgetSummaryProps) => {
  return (
    <Card title={title}>
      {rows.map((row) => (
        <div
          className={`budgetRow ${row.isTotal ? "total" : ""}`}
          key={row.label}
        >
          <span className="budgetLabel">{row.label}</span>
          <span
            className={`budgetVal ${row.variant || ""} ${row.size || ""}`.trim()}
          >
            {row.value}
          </span>
        </div>
      ))}
      {note ? (
        <div className={`noteBox mb-3 ${noteClass || ""}`.trim()}>{note}</div>
      ) : null}
      {progress ? (
        <div>
          <div className="progRow">
            <span className="progLabel">Time elapsed</span>
            <span className="progVal">{progress.timeValue}</span>
          </div>
          <ProgressBar value={parseFloat(progress.timeValue)} />
          <div className="progRow">
            <span className="progLabel">Work complete</span>
            <span className="progVal">{progress.workValue}</span>
          </div>
          <ProgressBar value={parseFloat(progress.workValue)} />
        </div>
      ) : null}
    </Card>
  );
};

export default BudgetSummary;
